<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="页面计划"
      :innerHeight="500"
      width="810px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <div v-for="(item, index) in skuList" :key="index">
        <div class="sku-item-header">
          <el-row :gutter="10">
            <el-col :span="6">sku编码：{{item.skuCode}}</el-col>
            <el-col :span="12">sku名称：{{item.skuName}}</el-col>
            <el-col :span="6" style="text-align: right;">
              <transition name="slidex">
                <el-tag
                  type="primary"
                  v-if="activeSku && relationSku.indexOf(item.skuCode) > -1"
                  closable
                  size="small"
                  @close="handleTagClose(item.skuCode)"
                >{{activeSku}}</el-tag>
                <el-button type="primary" size="small" plain v-else @click="relationAllSku(item.skuCode)">同计划</el-button>
              </transition>
            </el-col>
          </el-row>
        </div>
        <div class="sku-item-form">
          <div class="relation-sku" v-if="activeSku === item.skuCode">
            <el-tag
              type="primary" v-for="(item, index) in relationSku" :key="index"
              closable
              size="small"
              @close="handleTagClose(item)"
            >{{activeSku}}</el-tag>
          </div>
          <el-form :model="item.form1" :inline="true" size="small" :disabled="relationSku.indexOf(item.skuCode) > -1">
            <el-tag type="warning" size="mini" class="form-tag">设计</el-tag>
            <el-form-item label="计划开始：">
              <el-input v-model.trim="item.form1.a"></el-input>
            </el-form-item>
            <el-form-item label="计划结束：">
              <el-input v-model.trim="item.form1.b"></el-input>
            </el-form-item>
            <el-form-item label="计划人员：">
              <el-input v-model.trim="item.form1.c"></el-input>
            </el-form-item>
          </el-form>
          <el-form :model="item.form2" :inline="true" size="small" :disabled="relationSku.indexOf(item.skuCode) > -1">
            <el-tag type="warning" size="mini" class="form-tag">切片</el-tag>
            <el-form-item label="计划开始：">
              <el-input v-model.trim="item.form2.a"></el-input>
            </el-form-item>
            <el-form-item label="计划结束：">
              <el-input v-model.trim="item.form2.b"></el-input>
            </el-form-item>
            <el-form-item label="计划人员：">
              <el-input v-model.trim="item.form2.c"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="tips">提示：每个SKU的计划必须要完整填写，才能够继续。<span>如有遗漏则该SKU无法进入下一步！</span></div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible'],
  data() {
    return {
      dialogVisible: false,
      // 业务
      skuList: [
        {
          skuCode: '123303-DC-1.8',
          skuName: '102279正向布艺沙发（1+3+转）1',
          form1: {},
          form2: {}
        },
        {
          skuCode: '123303-DC-2.8',
          skuName: '102279正向布艺沙发（1+3+转）2',
          form1: {},
          form2: {}
        },
        {
          skuCode: '123303-DC-3.8',
          skuName: '102279正向布艺沙发（1+3+转）3',
          form1: {},
          form2: {}
        },
        {
          skuCode: '123303-DC-4.8',
          skuName: '102279正向布艺沙发（1+3+转）4',
          form1: {},
          form2: {}
        }
      ],
      form: {},
      activeSku: '',
      relationSku: []
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
    // 业务
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.$refs['ruleForm'].validate(valid=>{
        if(valid) {
          this.updateVal();
        }
      })
    },
    // 业务
    // 取消关联
    handleTagClose(code) {
      this.relationSku = this.relationSku.filter(v=>v !== code);
      
      this.skuList.forEach(item=>{
        if(item.skuCode === code) {
          item.form1 = {};
          item.form2 = {};
        }
      })
    },
    async relationAllSku(code) {
      // 不是第一次同步，需要弹框提醒
      if(this.activeSku) {
        await this.$confirm('已有关联SKU，是否需要清空重新关联该SKU？', '提示')
      }

      this.relationSku = this.skuList.map(v=>v.skuCode).filter(v=>v!==code);
      console.log(this.relationSku);
      this.activeSku = code;
      console.log(code)

      // 同步表单
      let mainSkuItem = this.skuList.find(v=>v.skuCode === this.activeSku);
      this.skuList.forEach(item=>{
        if(this.relationSku.indexOf(item.skuCode) > -1) {
          item.form1 = mainSkuItem.form1;
          item.form2 = mainSkuItem.form2;
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-dialog__content
    overflow-x hidden
  .sku-item-header
    margin-bottom 10px
    >>> .el-col
      line-height 24px
  .sku-item-form
    >>> .el-form-item
      margin-bottom 10px
    .relation-sku
      margin-bottom 10px
      >>> .el-tag+.el-tag
        margin-left 5px

  .slidex-enter
    transform translateX(100px)
    opacity 0
  .slidex-enter-active,.slidex-leave-active
    transition all linear .3s
    opacity 1
    position absolute
    >>> .el-button
      display inline-block
  .slidex-leave-to
    transform translateX(-100px)
    opacity 0
  
  .form-tag
    position relative
    top 6px

  .tips
    font-size 14px
    margin-top 10px
    color #999
    span
      color #E63946
</style>